import { forceLogout, updateEventConfig } from '@redux/actions';
import { login, logout } from '@redux/actions/AuthService';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AuthState = {
  jwtAccessToken: '',
  jwtRefreshToken: '',
  user: null,
  config: {},
};

const removeAuth = (state: AuthState) => {
  state.jwtAccessToken = '';
  state.jwtRefreshToken = '';
  state.user = null;
};

const reducers = {
  updateTokens: (
    state: AuthState,
    action: PayloadAction<{ accessToken: string; refreshToken?: string }>
  ) => {
    state.jwtAccessToken = action.payload.accessToken;
    if (action.payload.accessToken) {
      state.jwtRefreshToken = action.payload.accessToken;
    }
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers,
  extraReducers: builder => {
    builder
      .addCase(updateEventConfig, (state, { payload }) => {
        state.config.event = payload;
      })
      .addCase(forceLogout, removeAuth)
      .addCase(login.fulfilled, (state, { payload }) => {
        if (
          payload.user &&
          payload.user.id !== +(state.config?.accountId || -1)
        ) {
          state.jwtRefreshToken = payload.token.accessToken;
          state.jwtAccessToken = payload.token.accessToken;
          state.user = payload.user;
          if (payload.user.id !== +(state.config?.accountId || -1)) {
            state.config = {
              accountId: payload.user.accountId,
              event: { time: 30, enabled: true },
            };
          }
        }
      })
      .addCase(logout.fulfilled, removeAuth);
  },
});

export const { updateTokens } = authSlice.actions;

export default authSlice.reducer;
